import React, { useState, useEffect } from 'react'
import { Button } from 'antd'
import { EditPanIcon } from '../../icons'
import RichText from '../../richText'
import { editClient } from '../../../api/team'
import { message } from 'antd'
import styles from './AspirationsGoalsSection.module.css'
import ConditionalHideWrap from './ConditionalHidewrap'

export default function AspirationsGoalsSection(props) {
  const {
    person = null,
    loginRole = '',
    view = '',
    hideSectionHandle = () => {},
    hideSection = []
  } = props

  const [isEditing, setIsEditing] = useState(false)
  const [isEditingLTA, setIsEditingLTA] = useState(false)
  const [displayData, setDisplayData] = useState({
    areas_of_focus:
      (person && person.profile && person.profile.areas_of_focus) || '',
    long_term_aspirations:
      (person && person.profile && person.profile.long_term_aspirations) || ''
  })

  const isEditable =
    (loginRole === 'Expert' || loginRole === 'InternalAdmin') &&
    view === 'Draft'

  const saveAreaOfFocus = async () => {
    if (!person || !person.id) {
      message.error('Invalid person data')
      return
    }
    try {
      const areas_of_focus = (displayData.areas_of_focus || '')
        .replace(/<ul>/g, '<ul style="padding-left: 15px">')
        .replace(/<ol>/g, '<ol style="padding-left: 15px">')
      await editClient({ profile: { areas_of_focus } }, person.id)
      setIsEditing(false)
      setDisplayData((prev) => ({ ...prev, areas_of_focus: areas_of_focus }))
      message.success('Goals updated successfully')
    } catch (error) {
      message.error('Failed to update goals')
    }
  }

  const saveLTA = async () => {
    if (!person || !person.id) {
      message.error('Invalid person data')
      return
    }
    try {
      const formatData = (displayData.long_term_aspirations || '')
        .replace(/<ul>/g, '<ul style="padding-left: 15px">')
        .replace(/<ol>/g, '<ol style="padding-left: 15px">')
      await editClient(
        { profile: { long_term_aspirations: formatData } },
        person.id
      )
      setIsEditingLTA(false)
      setDisplayData((prev) => ({
        ...prev,
        long_term_aspirations: formatData
      }))
      message.success('Aspirations updated successfully')
    } catch (error) {
      message.error('Failed to update aspirations')
    }
  }

  useEffect(() => {
    setDisplayData({
      areas_of_focus:
        (person && person.profile && person.profile.areas_of_focus) || '',
      long_term_aspirations:
        (person && person.profile && person.profile.long_term_aspirations) ||
        ''
    })
  }, [person])

  if (!person || !person.profile) {
    return null
  }

  return (
    <ConditionalHideWrap
      name="Aspirations & Goals"
      title="Aspirations & Goals"
      isSection={true}
      syncStatus={(name, status) => hideSectionHandle(name, status)}
      status={hideSection || []}
      view={view}
      condition={view === 'Draft' || (view === 'Preview' && !hideSection.includes('Aspirations & Goals'))}
    >
      <section className={styles.section}>
        <h1 className={styles.sectionTitle}>Aspirations & Goals</h1>
        <div className={styles.contentContainer}>
          {/* Aspirations Card */}
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>
              Aspirations
              {isEditable && (
                <div className={styles.editControls}>
                  {isEditingLTA ? (
                    <>
                      <Button
                        type="primary"
                        ghost
                        onClick={() => {
                          setIsEditingLTA(false)
                          setDisplayData((prev) => ({
                            ...prev,
                            long_term_aspirations:
                              (person &&
                                person.profile &&
                                person.profile.long_term_aspirations) ||
                              ''
                          }))
                        }}
                        style={{ marginRight: 8 }}
                      >
                        Cancel
                      </Button>
                      <Button type="primary" onClick={saveLTA}>
                        Save
                      </Button>
                    </>
                  ) : (
                    <EditPanIcon
                      onClick={() => setIsEditingLTA(true)}
                      className={styles.editIcon}
                    />
                  )}
                </div>
              )}
            </h3>
            <div className={styles.cardContent}>
              {isEditable && isEditingLTA ? (
                <RichText
                  value={displayData.long_term_aspirations}
                  onChange={(value) =>
                    setDisplayData((prev) => ({
                      ...prev,
                      long_term_aspirations: value
                    }))
                  }
                  fontsizeOnly={true}
                  toolbar={{
                    options: ['fontSize', 'list'],
                    list: {
                      options: ['unordered', 'ordered']
                    }
                  }}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: displayData.long_term_aspirations
                  }}
                />
              )}
            </div>
          </div>

          {/* Goals Card */}
          <div className={styles.card}>
            <h3 className={styles.cardTitle}>
              Goals
              {isEditable && (
                <div className={styles.editControls}>
                  {isEditing ? (
                    <>
                      <Button
                        type="primary"
                        ghost
                        onClick={() => {
                          setIsEditing(false)
                          setDisplayData((prev) => ({
                            ...prev,
                            areas_of_focus:
                              (person &&
                                person.profile &&
                                person.profile.areas_of_focus) ||
                              ''
                          }))
                        }}
                        style={{ marginRight: 8 }}
                      >
                        Cancel
                      </Button>
                      <Button type="primary" onClick={saveAreaOfFocus}>
                        Save
                      </Button>
                    </>
                  ) : (
                    <EditPanIcon
                      onClick={() => setIsEditing(true)}
                      className={styles.editIcon}
                    />
                  )}
                </div>
              )}
            </h3>
            <div className={styles.cardContent}>
              {isEditable && isEditing ? (
                <RichText
                  value={displayData.areas_of_focus}
                  onChange={(value) =>
                    setDisplayData((prev) => ({
                      ...prev,
                      areas_of_focus: value
                    }))
                  }
                  fontsizeOnly={true}
                  toolbar={{
                    options: ['fontSize', 'list'],
                    list: {
                      options: ['unordered', 'ordered']
                    }
                  }}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: displayData.areas_of_focus
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </ConditionalHideWrap>
  )
}
